<template>
    <ul class="special-events-list" :class="{ 'has-bullet-points': items.length > 1 }">
        <li v-for="(item, index) in items" :key="index" :class="[item.className, 'small-text']">{{ item.text }}</li>
    </ul>
</template>

<script>
export default {
    name: 'CalendarTooltipList',
    props: {
        items: { type: Array, required: true },
    },
};
</script>
